/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Meta_TitleInputs */

const es_cap_meta_title = /** @type {(inputs: Cap_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Capitanes — Navega más, a tu manera`)
};

const gl_cap_meta_title = /** @type {(inputs: Cap_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Patróns — Navega máis, ao teu modo`)
};

const en_cap_meta_title = /** @type {(inputs: Cap_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Skippers — Sail more, your way`)
};

/**
* | output |
* | --- |
* | "Zarpar · Skippers — Sail more, your way" |
*
* @param {Cap_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_meta_title = /** @type {((inputs?: Cap_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_meta_title(inputs)
	if (locale === "en") return en_cap_meta_title(inputs)
	return es_cap_meta_title(inputs)
});